const cloudList = () => import('@/pages/cloud/list')
const operationCloud = () => import('@/pages/cloud/operation')

export default [
  {
    path: '/cloud-list',
    component: cloudList,
    name: 'cloudList',
    meta: [
      {
        name: '云空间管理',
        url: '/cloud-list'
      },
      {
        name: '分类列表',
        url: '/cloud-list'
      }
    ]
  },
  {
    path: '/cloud-list/add',
    component: operationCloud,
    meta: [
      {
        name: '分类列表',
        url: '/cloud-list'
      },
      {
        name: '新增分类',
        url: '/cloud-list/add'
      }
    ]
  },
  {
    path: '/cloud-list/set/:id',
    component: operationCloud,
    meta: [{
      name: '分类列表',
      url: '/cloud-list'
    },
    {
      name: '编辑分类',
      url: '/cloud-list/set/:id'
    }
    ]
  }
]
